<template>
<div id="app">
  <router-view/>

  <div class="section">
    <Websocket
      key="wsConsumer"
      ref="ws"
      v-bind:wsConsumer="wsConsumer"
      v-bind:wsDebug="wsDebug">
    </Websocket>
  </div>

</div>
</template>

<script>
import { mapState } from 'vuex'
import update from './mixins/update'
import Websocket from '@/components/Websocket'

export default {
  components: {
    Websocket
  },
  mixins: [update],
  data () {
    return {
      wsConsumer: 'mmcc',
      wsDebug: true
    }
  },
  computed: {
    ...mapState({
      isConnected: state => state.websocket.isConnected
    })
  }
}
</script>

<style>
</style>
